;(function() {
  'use strict'

  angular.module('core.kitGrid', [])
})()
